export const strings = {
  title: 'Print Certificates',
  subtitle: "A programme's certificates, and who they were issued to",
  downloadCertificates: 'Download certificates',
  downloadList: 'Download user list',
  selectAll: 'Select all',
  chooseProgram: 'Choose a programme to see who holds its certificates',
  empty: 'No matching certificates',
  actionFailed: 'The operation could not be completed',
  fail: {
    page: 'Could not load the certificate printing page',
    list: 'Could not load the certificates',
    print: 'Could not print the certificate',
  },

  filter: {
    program: 'Programme',
    from: 'From',
    to: 'To',
  },

  columns: {
    index: '#',
    username: 'Username',
    name: 'Name',
    email: 'Email',
    group: 'Department',
    issuedOn: 'Issued',
    expiresOn: 'Expires',
    daysLeft: 'Remaining',
  },
}
